import styled from 'styled-components';
import { media } from '../../../Utils/mediaQueries';

export const RowLeaderboards = styled.div`
    display: flex;
    flex-wrap: wrap;
    ${media.tablet`
        justify-content: center
    `};
`;

export const ControlLeaderBoardsWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 2%;

    ${props => {
        if (props.center) {
            return `
                width: 566px;
                justify-content: cneter;
            `;
        } else {
            return `
                width: 782px;
                @media (max-width: 1118px) {
                    width: 716px;
                }
            
                ${media.tablet`
                    width: 782px;
                `};
            
                ${media.phone`
                    width: 716px;
                `};
            
                @media (max-width: 696px) {
                    width: calc(100vw - 50px);
                }
            `;
        }
    }};
`;

export const InfoWrapper = styled.div`
    flex-grow: 1;
    display: flex;
    justify-content: space-between;
    ${media.phone`
        display: flex;
        width: 50%;
        flex-direction: column;
    `};
`;

export const ButtonWrapper = styled.div`
    ${media.phone`
        width: 50%;
        display: flex;
        justify-content: flex-end;
        align-items: center;
    `};
`;

export const SeletedWrapperBox = styled.div`
    margin: 0 10px;

    ${media.phone`
        margin: 10px 0;
    `};
`;



// WEBPACK FOOTER //
// ./src/UI/Containers/SelectionForLeaderBoards/style.js